import Route from "@ember/routing/route"

export default class OnboardRoute extends Route {
  // This handles old bookmarks people have
  beforeModel /* transition */() {
    this.transitionTo("planbook.show.planner.week") // Implicitly aborts the on-going transition.
  }
}
